/// <reference path="../app.typings.d.ts" />
'use strict';
var ApplicationRoleType;
(function (ApplicationRoleType) {
    /** Application access roles such as Admin, Manager, etc... */
    ApplicationRoleType[ApplicationRoleType["ApplicationUserRole"] = 1] = "ApplicationUserRole";
    /** Product access roles such as MultiPoint, Appointments, etc... */
    ApplicationRoleType[ApplicationRoleType["ProductUserRole"] = 2] = "ProductUserRole";
})(ApplicationRoleType || (ApplicationRoleType = {}));
/** A list of claims matching the back-end claim ids */
var AutoPointClaim;
(function (AutoPointClaim) {
    /** Basic Access reserved for users with the Technician role. */
    AutoPointClaim[AutoPointClaim["Technician"] = 1001] = "Technician";
    /** Basic Access reserved for users with the Service Advisor role. */
    AutoPointClaim[AutoPointClaim["ServiceAdvisor"] = 1002] = "ServiceAdvisor";
    /** Basic Access reserved for users with the Manager role. */
    AutoPointClaim[AutoPointClaim["Manager"] = 1003] = "Manager";
    /** Basic Access reserved for users with the Parts role. */
    AutoPointClaim[AutoPointClaim["Parts"] = 1004] = "Parts";
    /** Basic Access reserved for users with the Used Vehicle Manager role. */
    AutoPointClaim[AutoPointClaim["UsedVehicleManager"] = 1005] = "UsedVehicleManager";
    /** Basic Access reserved for users with the Admin role. */
    AutoPointClaim[AutoPointClaim["Admin"] = 1006] = "Admin";
    /** Basic Access reserved for users with the CPO Admin role. */
    AutoPointClaim[AutoPointClaim["CPOAdmin"] = 1007] = "CPOAdmin";
    /** Basic Access reserved for users with the Read Only role. */
    AutoPointClaim[AutoPointClaim["ReadOnly"] = 1008] = "ReadOnly";
    /** Basic Access reserved for users with the BDC User role. */
    AutoPointClaim[AutoPointClaim["BDCUser"] = 1009] = "BDCUser";
    /** Indicates the user has access to MultiPoint Application. */
    AutoPointClaim[AutoPointClaim["MultiPoint"] = 10001] = "MultiPoint";
    /** Indicates the user has access to Welcome Point Application. */
    AutoPointClaim[AutoPointClaim["WelcomePoint"] = 10002] = "WelcomePoint";
    /** Indicates the user has access to Appointments Application. */
    AutoPointClaim[AutoPointClaim["Appointments"] = 10003] = "Appointments";
    /** Indicates the user has access to Enterprise Reports Application. */
    AutoPointClaim[AutoPointClaim["EnterpriseReports"] = 1017] = "EnterpriseReports";
    /** Indicates the user has access to Dealer Reports Application. */
    AutoPointClaim[AutoPointClaim["DealerReports"] = 1018] = "DealerReports";
    /** Indicates the user has access to User Reports Application. */
    AutoPointClaim[AutoPointClaim["UserReports"] = 1019] = "UserReports";
    /** Indicates the user has access to Internal Reports Application. */
    AutoPointClaim[AutoPointClaim["InternalReports"] = 1020] = "InternalReports";
})(AutoPointClaim || (AutoPointClaim = {}));
/** A list of roles matching the back-end role ids (These should be converted to a dynamic lookup based on claims rather than roles. */
var AutoPointRole;
(function (AutoPointRole) {
    /** Basic Access reserved for users with the Technician role. */
    AutoPointRole[AutoPointRole["Technician"] = 1] = "Technician";
    /** Basic Access reserved for users with the Service Advisor role. */
    AutoPointRole[AutoPointRole["ServiceAdvisor"] = 2] = "ServiceAdvisor";
    /** Basic Access reserved for users with the Manager role. */
    AutoPointRole[AutoPointRole["ServiceManager"] = 3] = "ServiceManager";
    /** Basic Access reserved for users with the Parts role. */
    AutoPointRole[AutoPointRole["Parts"] = 4] = "Parts";
    /** Basic Access reserved for users with the Used Vehicle Manager role. */
    AutoPointRole[AutoPointRole["UsedVehicleManager"] = 5] = "UsedVehicleManager";
    /** Basic Access reserved for users with the Admin role. */
    AutoPointRole[AutoPointRole["Admin"] = 6] = "Admin";
    /** Basic Access reserved for users with the CPO Admin role. */
    AutoPointRole[AutoPointRole["CPOAdmin"] = 7] = "CPOAdmin";
    /** Basic Access reserved for users with the Read Only role. */
    AutoPointRole[AutoPointRole["ReadOnly"] = 8] = "ReadOnly";
    /** Basic Access reserved for users with the BDC User role. */
    AutoPointRole[AutoPointRole["BusinessDevelopmentCenterUser"] = 9] = "BusinessDevelopmentCenterUser";
    /** Indicates the user has access to MultiPoint Application. */
    AutoPointRole[AutoPointRole["MultiPointUser"] = 10] = "MultiPointUser";
    /** Indicates the user has access to Welcome Point Application. */
    AutoPointRole[AutoPointRole["WelcomePointUser"] = 11] = "WelcomePointUser";
    /** Indicates the user has access to Appointments Application. */
    AutoPointRole[AutoPointRole["AppointmentsUser"] = 12] = "AppointmentsUser";
    /** Indicates the user has access to Group Reports Application. */
    AutoPointRole[AutoPointRole["EnterpriseReportsUser"] = 21] = "EnterpriseReportsUser";
    /** Indicates the user has access to Dealer Reports Application. */
    AutoPointRole[AutoPointRole["DealerReportsUser"] = 22] = "DealerReportsUser";
    /** Indicates the user has access to User Reports Application. */
    AutoPointRole[AutoPointRole["UserReportsUser"] = 23] = "UserReportsUser";
    /** Indicates the user has access to Internal Reports Application. */
    AutoPointRole[AutoPointRole["InternalReportsUser"] = 24] = "InternalReportsUser";
})(AutoPointRole || (AutoPointRole = {}));
var CrudAction;
(function (CrudAction) {
    CrudAction[CrudAction["Initialized"] = 0] = "Initialized";
    CrudAction[CrudAction["Added"] = 100] = "Added";
    CrudAction[CrudAction["Deleted"] = 200] = "Deleted";
    CrudAction[CrudAction["Updated"] = 300] = "Updated";
})(CrudAction || (CrudAction = {}));
var InputDateFormat;
(function (InputDateFormat) {
    /* Short Form includes dates that start with 'MTD' format */
    InputDateFormat[InputDateFormat["ShortForm"] = 0] = "ShortForm";
    /* Long Form includes dates that start with 'Current Month' format */
    InputDateFormat[InputDateFormat["LongForm"] = 1] = "LongForm";
    /* Dual Long Form, mostly for ER History Trending or similar format */
    InputDateFormat[InputDateFormat["DualForm"] = 2] = "DualForm";
    /* Custom Form includes dates that have a custom start and end date */
    InputDateFormat[InputDateFormat["CustomForm"] = 3] = "CustomForm";
})(InputDateFormat || (InputDateFormat = {}));
var HttpRequestType;
(function (HttpRequestType) {
    HttpRequestType[HttpRequestType["GET"] = 1] = "GET";
    HttpRequestType[HttpRequestType["POST"] = 2] = "POST";
    HttpRequestType[HttpRequestType["PUT"] = 3] = "PUT";
    HttpRequestType[HttpRequestType["DELETE"] = 4] = "DELETE";
})(HttpRequestType || (HttpRequestType = {}));
/* Maps to the Matrix.Report.ReportDataType table */
var MetaParameters;
(function (MetaParameters) {
    MetaParameters[MetaParameters["AlphaOrg"] = 0] = "AlphaOrg";
    MetaParameters[MetaParameters["DateRangeStyle1"] = 1] = "DateRangeStyle1";
    MetaParameters[MetaParameters["DateRangeStyleStartEnd"] = 2] = "DateRangeStyleStartEnd";
    MetaParameters[MetaParameters["DateRangeStart"] = 3] = "DateRangeStart";
    MetaParameters[MetaParameters["DateRangeEnd"] = 4] = "DateRangeEnd";
    MetaParameters[MetaParameters["Checkbox"] = 5] = "Checkbox";
    MetaParameters[MetaParameters["MultiCheckbox"] = 6] = "MultiCheckbox";
    MetaParameters[MetaParameters["OrganizationUnit"] = 7] = "OrganizationUnit";
    MetaParameters[MetaParameters["DateRangeStyle2"] = 8] = "DateRangeStyle2";
})(MetaParameters || (MetaParameters = {}));
var ModalActionResult;
(function (ModalActionResult) {
    ModalActionResult[ModalActionResult["Dismissed"] = 1] = "Dismissed";
    ModalActionResult[ModalActionResult["Saved"] = 2] = "Saved";
    ModalActionResult[ModalActionResult["Failed"] = 3] = "Failed";
})(ModalActionResult || (ModalActionResult = {}));
var ModalSize;
(function (ModalSize) {
    ModalSize[ModalSize["Large"] = 1] = "Large";
    ModalSize[ModalSize["Medium"] = 2] = "Medium";
    ModalSize[ModalSize["Small"] = 3] = "Small";
})(ModalSize || (ModalSize = {}));
var OrganizationUnitType;
(function (OrganizationUnitType) {
    /** Organization Sub-Level. Indicates the organization unit is not a physical location but a virtual entity that is considered part of the organization hierarchy. */
    OrganizationUnitType[OrganizationUnitType["OrganizationSubLevel"] = 1] = "OrganizationSubLevel";
    /** Location. Indicates the organization unit is a physical location. */
    OrganizationUnitType[OrganizationUnitType["Location"] = 2] = "Location";
    /** GlobalOrganization. Indicates the organization is an Alpha level organization */
    OrganizationUnitType[OrganizationUnitType["GlobalOrganization"] = 3] = "GlobalOrganization";
})(OrganizationUnitType || (OrganizationUnitType = {}));
var ThirdParty;
(function (ThirdParty) {
    ThirdParty["RedCap"] = "redcap";
})(ThirdParty || (ThirdParty = {}));
var ReportTitles;
(function (ReportTitles) {
    ReportTitles[ReportTitles["ProcessMetrics"] = 1] = "ProcessMetrics";
    ReportTitles[ReportTitles["SalesPerformance"] = 2] = "SalesPerformance";
    ReportTitles[ReportTitles["PerformanceAverages"] = 3] = "PerformanceAverages";
    ReportTitles[ReportTitles["ShopBenchmarks"] = 4] = "ShopBenchmarks";
})(ReportTitles || (ReportTitles = {}));
